// extracted by mini-css-extract-plugin
module.exports = {"root":"Controls_root__3rNg5","bag":"Controls_bag__9JHws","hand":"Controls_hand__dQ0Vo","actions":"Controls_actions__UhVL9"};